import { render } from "./SubscriberDetails.vue?vue&type=template&id=4013879e"
import script from "./SubscriberDetails.vue?vue&type=script&lang=js"
export * from "./SubscriberDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__